import Login from "../views/Login"
import Redirect from "../views/Login/redirect"
// import ResetPassword from "../views/ResetPassword"

export const MapPathRoute2Name = {
  'login': 'Login',
  'reset-password': 'Reset Password'
}

export const RouteIds = {
  Login: 'login',
  ResetPassword: 'reset-password',
  Redirect: "redirect",
}

// const DCERouteIds = {
//   Edit: ':id',
//   New: 'new'
// };

export const RoutePaths = {
  Login: ['', RouteIds.Login].join('/'),
  ResetPassword: ['', RouteIds.ResetPassword].join('/'),
  Redirect: ["", RouteIds.Redirect].join("/"),
}

export const PublicRoutes = {
  Login: {
    exact: true,
    id: RouteIds.Login,
    label: MapPathRoute2Name[RouteIds.Login],
    path: RoutePaths.Login,
    component: Login,
  },

   Redirect: {
    id: RouteIds.Redirect,
    label:'Redirect',
    path: RoutePaths.Redirect,
    component: Redirect,
  },
  // ResetPassword: {
  //   exact: true,
  //   id: RouteIds.ResetPassword,
  //   label: MapPathRoute2Name[RouteIds.ResetPassword],
  //   path: RoutePaths.ResetPassword,
  //   component: ResetPassword,
  // },
}